import { render, staticRenderFns } from "./content-modal.vue?vue&type=template&id=8e1f6b24"
import script from "./content-modal.vue?vue&type=script&lang=js"
export * from "./content-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports